import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);

const mm = gsap.matchMedia();

mm.add("(min-width: 1024px)", () => {
  const container = document.querySelector(".testimonial__list");
  const items = gsap.utils.toArray(".testimonial__list__item");

  if (!container || items.length < 2) return;

  gsap.to(items, {
    xPercent: -100 * (items.length - 1),
    ease: "none",
    scrollTrigger: {
      trigger: ".testimonial",
      start: "top top",
      end: () => "+=" + container.scrollWidth,
      scrub: true,
      pin: true,
      anticipatePin: 1,
      snap: 1 / (items.length - 1),
    },
  });
});

